import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { reduxForm, propTypes, Field, formValueSelector } from 'redux-form';
//
import { COUNTRY_CODES } from 'config/country-codes';
import { ROUTES } from 'config/constants';
import { mapStateToProps } from 'utils/redux-decorators';
import {
  TextField,
  PasswordField,
  DropdownField,
  PhoneField,
  Button,
} from 'components';
import { FormTile } from 'components/FormTile';
import { CheckboxField } from 'components/FormFields/CheckboxField';
import { validate } from './validate';

import './sign-up-form.scss';

const FORM_NAME = 'signUpForm';

const selector = formValueSelector(FORM_NAME);

@mapStateToProps((state) => ({
  countryCode: selector(state, 'countryCode'),
  inviteData: state?.authState?.authInfo?.inviteData,
}))
@reduxForm({
  form: FORM_NAME,
  validate,
  initialValues: {
    countryCode: 'US',
  },
})
export class SignUpForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    isFormProcessed: PropTypes.bool,
  };

  countriesList = COUNTRY_CODES.map(({ name, code }) => ({
    title: name,
    value: code,
  }));

  getTermsAndConditions = () => (
    <span>
      I accept the terms of the{' '}
      <a
        href="https://anovaevidence.com/terms-of-use/"
        target="_blank"
        rel="noopener noreferrer"
        className="sign-up-form__terms-link"
        onClick={(e) => e.stopPropagation()}
      >
        License Agreement
      </a>
    </span>
  );

  render() {
    const {
      handleSubmit,
      error,
      submitFailed,
      isFormProcessed,
      countryCode,
      inviteData = {},
    } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image sign-up-form"
        data-testid="sign-up-form"
      >
        <FormTile
          // withOverflow={true}
          isLoaderShow={isFormProcessed}
        >
          <FormTile.Header>
            <div className="form-description-logo">
              <img
                className="form-description-logo__img"
                src="/assets/images/logo/description-logo@2x.png"
                alt="Anova logo"
              />
            </div>
          </FormTile.Header>
          <FormTile.Body>
            <Field
              label="First Name:"
              name="firstName"
              component={TextField}
              fieldClassName="mt-14"
              maxLength={60}
              props={{ testId: 'first-name-input' }}
            />

            <Field
              label="Last Name:"
              name="lastName"
              component={TextField}
              fieldClassName="mt-7"
              maxLength={60}
              props={{ testId: 'last-name-input' }}
            />

            <Field
              label="Organization Email:"
              name="email"
              autoComplete="username email"
              disabled={inviteData.hasOwnProperty('email')}
              component={TextField}
              fieldClassName="mt-7"
              tooltipInfo="Organization email address required for registration"
              tooltipFor="field"
              tooltipType="bottom-left"
              props={{ testId: 'email-input' }}
            />

            <div style={{ display: 'none' }}>
              <Field name="invitedUserId" component={TextField} />
            </div>

            <div className="form-fields-grid-container">
              <Field
                name="password"
                props={{
                  autoComplete: 'new-password',
                  testId: 'password-input',
                }}
                component={PasswordField}
                fieldClassName="mt-7"
              />
              <Field
                name="repeatPassword"
                props={{
                  autoComplete: 'new-password',
                  testId: 'confirm-password-input',
                }}
                label="Confirm:"
                component={PasswordField}
                fieldClassName="mt-7"
              />
            </div>
            <div className="form-fields-grid-container">
              <Field
                name="countryCode"
                list={this.countriesList}
                label="Country:"
                defaultValue="US"
                initMessage="Select another location"
                component={DropdownField}
                fieldClassName="mt-11"
                search
                rowsCount={5}
              />
              <Field
                name="phone"
                countryCode={countryCode}
                component={PhoneField}
                fieldClassName="mt-11"
                props={{ testId: 'phone-input' }}
              />
            </div>

            <div className="mt-19 sign-up-form__terms">
              <Field
                name="acceptTermsAndConditions"
                label={this.getTermsAndConditions()}
                component={CheckboxField}
                fieldClassName="sign-up-form__checkbox"
                props={{ testId: 'terms-checkbox' }}
              />
            </div>
          </FormTile.Body>
          <FormTile.Footer>
            {error && submitFailed && (
              <div
                className="form-tile-footer__error"
                data-testid="error-message"
              >
                {error}
              </div>
            )}
            <div className="form-tile-footer__panel">
              <Link to={ROUTES.LOGIN} className="text-decoration-none">
                <Button className="_simple-red" dataTestId="sign-in">
                  Sign In
                </Button>
              </Link>
              <Button className="_red" type="submit" dataTestId="register">
                Sign Up
              </Button>
            </div>
          </FormTile.Footer>
        </FormTile>
      </form>
    );
  }
}
